import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from 'styled-components';
import config from './config/config';

// import Ui components
import App from './App';

// import styles
import './index.scss';
import './static/css/style.css';
import 'antd/dist/antd.less';

const root = ReactDOM.createRoot(document.getElementById('root'));
const { rtl, topMenu, mainTemplate, themeColor } = config;

root.render(
  <BrowserRouter>
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'} getPopupContainer={(trigger) => trigger.parentNode}>
      <ThemeProvider theme={{ ...themeColor, rtl, topMenu, mainContent: mainTemplate }}>
        <App />
      </ThemeProvider>
    </ConfigProvider>
  </BrowserRouter>,
);
